import uris from '~/uris';
import {DISABLE_WEBSOCKET_SESSION_KEY} from '~/utils/constants';
import SessionStore from '~/stores/SessionStore';

class WebsocketService {
  onMessageFunctions = [];

  heartCheck = {
    timeout: 30000,
    timeoutObj: null,
    retryTimeoutObj: null,
    serverTimeoutObj: null,
    message: 'PING',
    serverMessage: 'PONG'
  };

  retryCount = 0;

  clearHearCheck() {
    clearTimeout(this.heartCheck.serverTimeoutObj);
    clearTimeout(this.heartCheck.timeoutObj);
  }

  resetHeartCheck() {
    this.retryCount = 0;
    this.clearHearCheck();
    this.startHeartCheck();
  }

  startHeartCheck() {
    if (this.socket) {
      this.heartCheck.timeoutObj = setTimeout(() => {
        if (this.socket.readyState === 1) {
          this.socket.send(this.heartCheck.message);
        }
        this.heartCheck.serverTimeoutObj = setTimeout(() => {
          this.socket.close();
        }, this.heartCheck.timeout);
      }, this.heartCheck.timeout);
    }
  }

  createConnection() {
    if (localStorage.getItem(DISABLE_WEBSOCKET_SESSION_KEY) === 'true') {
      return;
    }
    this.socket = new WebSocket(uris.socket());
    this.socket.onmessage = this.onMessage;
    this.socket.onclose = this.onClose;
    this.socket.onopen = this.onOpen;
    this.socket.onerror = this.onClose;
  }

  getToken = () => `Bearer ${SessionStore.tokenInCookie}`;

  subscribe(...rest) {
    this.onMessageFunctions = rest;
    if (this.socket) {
      this.socket.close();
    } else {
      this.createConnection();
    }
  }

  onMessage = (event) => {
    this.resetHeartCheck();
    this.onMessageFunctions.forEach((f) => {
      if (typeof f === 'function' && event.data === 'UNAUTHORIZED_TOKEN') {
        this.socket.send(this.getToken());
      } else if (typeof f === 'function' && event.data !== this.heartCheck.serverMessage) {
        f(JSON.parse(event.data));
      }
    });
    return false;
  };

  onOpen = () => {
    if (this.socket) {
      this.socket.send(this.getToken());
    }
    this.startHeartCheck();
  };

  send = (message) => {
    if (this.socket) {
      this.socket.send(message);
    } else {
      this.createConnection();
    }
  }

  onClose = () => {
    clearTimeout(this.heartCheck.retryTimeoutObj);
    this.heartCheck.retryTimeoutObj = setTimeout(() => {
      if (this.retryCount < 5) {
        this.createConnection();
      }
    }, 1000);
  };
}

export default new WebsocketService();
